module.exports = __webpack_public_path__ + "media/theme/tutorial__dmm--4--redeem-9ff83089.png";